<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("feature", 2) }}
      </div>
      <router-link class="btn-blue" to="features"
        >{{ $tc("feature", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Features"
          :key="index"
          v-if="item.fieldname !== 'feature_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.type !== 'radio' && item.type !== 'dropdown'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
            </div>
            <p
              v-if="submitted && errors.has(item.fieldname)"
              class="error_message"
            >
              <!-- {{ item.fieldname }} -->
              {{ errors.first(`${item.fieldname}`) }}
            </p>
          </div>

          <div v-if="item.type === 'radio'" class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <!-- <label class="ios-switch"> -->
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox"
              v-model="item.fieldvalue"
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>

          <div v-if="item.type === 'dropdown'">
            <div v-if="item.fieldname === 'module_id'">
              <div class="dropdown-curve-container">
                <label
                  :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                  >{{ $tc(item.label, 1) }}</label
                >
                <b-dropdown
                  :text="item.dropdownSelected"
                  variant="dropdown-curve"
                  class="w-100"
                >

                <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search Module"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchModule()"
                        v-on:keydown="onSearchModule()"
                        v-model="searchModule"
                      />
                    </div>
                  <b-dropdown-item
                    v-for="(dropdownItem, dropdownIndex) in moduleList"
                    :key="dropdownIndex"
                    @click="
                      onDropdownChange($event, item.label, dropdownItem, index)
                    "
                    name="select_module"
                    id="select_module"
                    >{{ dropdownItem.module_name }}</b-dropdown-item
                  >
                </b-dropdown>

                <p
                  v-if="submitted && item.dropdownSelected.length <= 0"
                  class="error_message"
                >
                  Please Select Module
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="features">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Features from "@/helper/formJSONMaster/Features";

export default {
  data() {
    return {
      btenable: false,
      messagemodule: "Please Select Module.",
      Features: Features.ms_features,
      submitted: false,
      Methods: Features.Methods,
      moduleList: [],
      moduleListCopy: [],
      searchModule: "",
    };
  },
  beforeMount() {
    this.getModuleList();
    this.resetHandler();
  },
  mounted() {
    console.log("Features :", Features);
    this.resetHandler();
  },
  methods: {
    onFocusHandler: function () {},

    onSearchModule: function () {
      if(this.searchModule && this.searchModule.length > 0){
        this.moduleList = this.moduleListCopy.filter((x) => {
          return x.module_name.toLowerCase().includes(this.searchModule.toLowerCase());
        });
      }else{
        this.moduleList = this.moduleListCopy;
      }
    },
    getModuleList: function () {
      let body = this.getRequestBody("GET", undefined, {
        GET: "",
        tableName: "ms_modules",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          // console.log('data:', data)
          if (data && data.data.length > 0) {
            this.moduleList = data.data;
            this.moduleListCopy = data.data;
            // console.log('this.moduleList:', this.moduleList);
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onDropdownChange: function (event, type, item, mainIndex) {
      // console.log("item :", item);
      this.Features[mainIndex].fieldvalue = item.module_id;
      this.Features[mainIndex].dropdownSelected = item.module_name;
    },
    resetHandler: function () {
      this.Features.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = "";
        }
      });
    },
    handleSubmit(flag) {
      this.submitted = false;
      console.log("call submit :");
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;
          console.log("valid :", valid);
          let body = this.getRequestBody("POST", this.Features, this.Methods);
          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.resetHandler();
                if (flag) {
                  this.$router.push({
                    path: "/master/features",
                  });
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch((error) => {
              console.log("show error2 :", error);
            });
        } else {
          this.submitted = true;

          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/FeaturesComponents/addFeature.vue